var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "call_svg__a",
    width: 21,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h20v20H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#call_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.7 17.083q-2.355 0-4.732-1.095t-4.37-3.09-3.086-4.37Q3.417 6.156 3.417 3.8a.86.86 0 0 1 .875-.883H7.01q.315 0 .557.205.24.206.307.51l.477 2.451q.05.342-.02.587a.87.87 0 0 1-.254.412L6.153 8.955q.465.85 1.061 1.61.597.759 1.293 1.45a14.4 14.4 0 0 0 3.126 2.368l1.87-1.886q.196-.204.474-.286a1.4 1.4 0 0 1 .578-.04l2.314.472q.315.082.515.322.2.239.2.541v2.702q0 .375-.253.625a.86.86 0 0 1-.63.25M5.562 7.773l1.487-1.424a.15.15 0 0 0 .052-.088.2.2 0 0 0-.004-.104l-.362-1.862a.17.17 0 0 0-.056-.096.16.16 0 0 0-.104-.033H4.792a.1.1 0 0 0-.08.033.1.1 0 0 0-.032.08 10.7 10.7 0 0 0 .881 3.493m7.25 7.201a8.6 8.6 0 0 0 1.729.59 10 10 0 0 0 1.681.243.11.11 0 0 0 .113-.112v-1.753a.16.16 0 0 0-.032-.104.17.17 0 0 0-.097-.056l-1.75-.356a.13.13 0 0 0-.084-.004.2.2 0 0 0-.076.052z"
  }))));
};
export default SvgCall;